import { gql } from '@apollo/client';

export const SEARCH_WINE_MATRIX = gql`
  query SearchWineMatrix(
    $from: Int!
    $pageSize: Int!
    $tab: String!
    $sortFilter: String
    $sortOrder: String
    $wineName: String
    $filters: WineMatrixFilters
  ) {
    searchWineMatrix(
      from: $from
      pageSize: $pageSize
      tab: $tab
      sortFilter: $sortFilter
      sortOrder: $sortOrder
      wineName: $wineName
      filters: $filters
    ) {
      total
      results {
        id
        maxVintage
        minVintage
        maxTradeCount
        minTradeCount
        maxWs1b
        minWs1b
        maxUk1b
        minUk1b
        data {
          lwin
          wineName
          vintage
          wsGrade
          liquidity
          tradeCount
          score
          return1yrWs
          compGrade
          wsPrice
          ukPriceMin
          value
        }
      }
    }
  }
`;
